import { Sparkles } from 'lucide-react';
import { HintNote } from '@/components/ui/design-system/HintNote';
import { cn } from '@/lib/utils';

interface FeedInsightProps {
  text: string;
  /** `top` lands directly under the stage rail; others sit between sections. */
  placement?: 'top' | 'between' | 'bottom';
  className?: string;
}

/**
 * Short LLM-written paragraph block. Wraps the shared `HintNote` primitive so
 * we get consistent styling with other inline notes across the app, and only
 * customize the icon + emphasis based on placement.
 */
export function FeedInsight({ text, placement = 'between', className }: FeedInsightProps) {
  const isTop = placement === 'top';
  return (
    <HintNote
      icon={
        <Sparkles
          className={cn(
            'h-3.5 w-3.5',
            isTop ? 'text-primary' : 'text-muted-foreground',
          )}
        />
      }
      className={cn(
        isTop && 'border-primary/30 bg-primary/[0.04] text-foreground/90',
        className,
      )}
    >
      {text}
    </HintNote>
  );
}
